
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5SYww", function(module, exports) {
/* PagesItemActions.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $jYwSK = parcelRequire("jYwSK");


var $gm2vG = parcelRequire("gm2vG");


var $9DHhW = parcelRequire("9DHhW");


var $jmjWc = parcelRequire("jmjWc");

var $luv00 = parcelRequire("luv00");


var $5pCWF = parcelRequire("5pCWF");


var $6MlZq = parcelRequire("6MlZq");


var $2vuKf = parcelRequire("2vuKf");


var $bwL2u = parcelRequire("bwL2u");

/* MultiSelectButton.tsx generated by @compiled/babel-plugin v3.0.2 */ /* This is an entrypoint for multi-select in the content tree. It opens the BulkActionsMenu, which can be found in @confluence/page-tree */ 



var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $fg2tf = parcelRequire("fg2tf");


var $hBYtq = parcelRequire("hBYtq");


var $9GVkD = parcelRequire("9GVkD");





var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $386eff14c577d57a$export$bf2468c1c6a5e659 = ({ onClick: onClick, isDisabled: isDisabled, spaceHasUserContent: spaceHasUserContent, isPageTreeEmpty: isPageTreeEmpty, isMultiSelectEnabled: isMultiSelectEnabled, isLoading: isLoading, isMobile: isMobile })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hasFiredScreenEvent = (0, $cozmU.useRef)(false);
    const descriptionId = (0, $cozmU.useId)(); // only fire the screen event once when the sidebar is expanded
    (0, $cozmU.useEffect)(()=>{
        const tryFireScreenEvent = ()=>{
            if ((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED) === 'expanded' && !hasFiredScreenEvent.current) {
                hasFiredScreenEvent.current = true;
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'multiSelectButton'
                    }
                }).fire();
            }
        };
        tryFireScreenEvent();
        window.addEventListener('resize', tryFireScreenEvent);
        return ()=>{
            window.removeEventListener('resize', tryFireScreenEvent);
        };
    }, [
        createAnalyticsEvent
    ]);
    if (!spaceHasUserContent || isPageTreeEmpty || isMobile || !isMultiSelectEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fg2tf))),
        label: intl.formatMessage($386eff14c577d57a$var$i18n.enableMultiSelectLabel),
        "aria-describedby": descriptionId,
        appearance: "subtle",
        spacing: "compact",
        onClick: onClick,
        isTooltipDisabled: false,
        isDisabled: isLoading || isDisabled,
        tooltip: {
            content: isDisabled ? intl.formatMessage($386eff14c577d57a$var$i18n.disabledMultiSelectTooltipOnSearch) : intl.formatMessage($386eff14c577d57a$var$i18n.enableMultiSelect)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        id: descriptionId
    }, intl.formatMessage($386eff14c577d57a$var$i18n.enableMultiSelectPermissionNote)));
};
const $386eff14c577d57a$export$46ea206025f7f52d = ({ onClick: onClick })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        "aria-label": intl.formatMessage($386eff14c577d57a$var$i18n.exitMultiSelectLabel),
        onClick: onClick,
        xcss: $386eff14c577d57a$var$styles.exit,
        analyticsContext: {
            source: 'contentTreeBulkActions',
            attributes: {
                name: 'exitMultiSelectButton'
            }
        }
    }, intl.formatMessage($386eff14c577d57a$var$i18n.exitMultiSelect));
};
const $386eff14c577d57a$var$i18n = (0, $kSwu1.defineMessages)({
    exitMultiSelect: {
        id: "space-views.exit-multi-select",
        defaultMessage: "Exit"
    },
    exitMultiSelectLabel: {
        id: "space-views.exit-multi-select-label",
        defaultMessage: "Exit multi-select mode"
    },
    enableMultiSelectLabel: {
        id: "space-views.enable-multi-select-label",
        defaultMessage: "Select multiple items"
    },
    enableMultiSelect: {
        id: "space-views.enable-multi-select",
        defaultMessage: "Select multiple items to edit. Only items you have permission to modify will be affected."
    },
    enableMultiSelectPermissionNote: {
        id: "space-views.enable-multi-select-permission-note",
        defaultMessage: "Only items you have permission to modify will be affected."
    },
    disabledMultiSelectTooltipOnSearch: {
        id: "space-views.disabled-multi-select-tooltip",
        defaultMessage: "Multi-select is disabled when searching"
    }
});
const $386eff14c577d57a$var$styles = {
    exit: "_2sNsIgmnOE _2Y7lL41Y8M _42Yu6B7dHp _0jFU0VSPN1 _0KLXru66of _1UtDYzjTy9 _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8"
};


const $313e848f91dccb56$var$ActionsContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _2hByyXoWWg _15dZMtoWWg _1ZkjZVoWWg _10JwyroWWg _1fvON2oWWg _3gJBT0oWWg _3MiO30oWWg _3pHEdioWWg",
            __cmplp.className
        ])
    });
});

const $313e848f91dccb56$var$SpaceViewsMenuLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rKir-",
    name: "SpaceViewsMenuLoader",
    loader: async ()=>(await (parcelRequire("fZkiP"))).SpaceViewsMenu
});
const $313e848f91dccb56$export$bbecd2ee2d957a01 = ({ isLicensed: isLicensed, edition: edition, selection: selection, setSelection: setSelection, spaceKey: spaceKey, expandContentSection: expandContentSection, onItemClick: onItemClick, spaceHasUserContent: spaceHasUserContent, isPageTreeEmpty: isPageTreeEmpty, pageTreeFinishedLoading: pageTreeFinishedLoading, canManageContentOrSuperAdmin: canManageContentOrSuperAdmin, spaceViewsMenuTriggerRef: spaceViewsMenuTriggerRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const canShowFolder = selection === 'TREE';
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const isCreationADropdown = (0, $6MlZq.useIsCreationDropdownEnabled)();
    const [isContextualCreateFocused, setIsContextualCreateFocused] = (0, $cozmU.useState)(false);
    const [isContextualCreatePopupOpen, setIsContextualCreatePopupOpen] = (0, $cozmU.useState)(false);
    const [{ multiSelectMode: multiSelectMode }, { enterMultiSelect: enterMultiSelect, exitMultiSelect: exitMultiSelect }] = (0, $bwL2u.useContentTreeSelection)();
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    const [isMobile, setIsMobile] = (0, $cozmU.useState)(false);
    const mediaQuery = (0, $gm2vG.UNSAFE_useMediaQuery)('below.md', function onChange(event) {
        // shifting between mobile and desktop
        if (isMultiSelectActive) exitMultiSelect();
        setIsMobile(event.matches);
    });
    (0, $cozmU.useLayoutEffect)(()=>{
        setIsMobile(mediaQuery?.matches ?? false);
    }, [
        mediaQuery
    ]);
    const isMultiSelectEnabled = canManageContentOrSuperAdmin && edition === 'PREMIUM';
    const expandSideNav = (0, $jYwSK.useExpandSideNav)();
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'contentTreeBulkActions',
                    action: 'closed',
                    actionSubject: 'bulkActionsMenu',
                    attributes: {
                        method: 'unmount'
                    }
                }
            }).fire();
            exitMultiSelect();
        };
    }, [
        createAnalyticsEvent,
        exitMultiSelect
    ]);
    const spaceViewsMenu = isLicensed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($313e848f91dccb56$var$SpaceViewsMenuLoader, {
        selection: selection,
        setSelection: setSelection,
        isWhiteboardBetaEnabled: isCreationADropdown,
        edition: edition,
        canManageContentOrSuperAdmin: canManageContentOrSuperAdmin,
        triggerRef: spaceViewsMenuTriggerRef,
        isCompact: true
    }) : null;
    const contextualCreate = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5pCWF.ContextualCreateContentPopoverLoader), {
        isContextualCreateFocused: isContextualCreateFocused,
        setIsContextualCreateFocused: setIsContextualCreateFocused,
        shouldShowPopup: isContextualCreatePopupOpen,
        setShouldShowPopup: setIsContextualCreatePopupOpen,
        spaceKey: spaceKey,
        source: "spaceLevelContextualCreate",
        rootCreateButtonStyling: true,
        onItemClick: onItemClick,
        shouldRenderToParent: true,
        hideFolder: !canShowFolder
    }));
    const onMultiSelectClick = ()=>{
        expandSideNav();
        expandContentSection?.();
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'contentTreeBulkActions',
                action: 'opened',
                actionSubject: 'bulkActionsMenu',
                actionSubjectId: 'multiSelectButton'
            }
        }).fire();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'contentTreeBulkActions',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'multiSelectButton',
                attributes: {
                    spaceKey: spaceKey
                }
            }
        }).fire();
        enterMultiSelect();
    };
    const onExitMultiSelectClick = ()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'contentTreeBulkActions',
                action: 'closed',
                actionSubject: 'bulkActionsMenu',
                attributes: {
                    method: 'multiSelectExitButton'
                }
            }
        }).fire();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'contentTreeBulkActions',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'multiSelectExitButton'
            }
        }).fire();
        exitMultiSelect();
    };
    const actions = isMultiSelectActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $386eff14c577d57a$export$46ea206025f7f52d), {
        onClick: onExitMultiSelectClick
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isMultiSelectEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $386eff14c577d57a$export$bf2468c1c6a5e659), {
        onClick: onMultiSelectClick,
        isDisabled: multiSelectMode === (0, $bwL2u.MultiSelectMode).DISABLED,
        isLoading: !pageTreeFinishedLoading,
        spaceHasUserContent: spaceHasUserContent,
        isPageTreeEmpty: isPageTreeEmpty,
        isMultiSelectEnabled: isMultiSelectEnabled,
        isMobile: isMobile
    }), contextualCreate, !isMultiSelectEnabled && spaceViewsMenu);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($313e848f91dccb56$var$ActionsContainer, {
        "data-vc": "pages-item-actions",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, actions));
};
module.exports["PagesItemActions"] = $313e848f91dccb56$export$bbecd2ee2d957a01;

});

parcelRegister("gm2vG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $1NWCx = parcelRequire("1NWCx");


var $45mGg = parcelRequire("45mGg");

const $2eec9d500aa9cc66$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $45mGg.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $2eec9d500aa9cc66$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $cozmU.useRef)(listener);
    (0, $cozmU.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ const hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ const mq = $2eec9d500aa9cc66$var$queries[queryString];
    (0, $1NWCx.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $cbY7C.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};
module.exports["UNSAFE_useMediaQuery"] = $2eec9d500aa9cc66$export$49e55ae2c03d6045;

});

parcelRegister("45mGg", function(module, exports) {

var $gnKXs = parcelRequire("gnKXs");

const $61f180d366254050$export$c881183ca713c214 = (0, $gnKXs.media);
module.exports["UNSAFE_media"] = $61f180d366254050$export$c881183ca713c214;

});

parcelRegister("gnKXs", function(module, exports) {
const $cd9ae1db5a8ec9c9$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
module.exports["media"] = $cd9ae1db5a8ec9c9$export$987d49ffe1b0900f;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("5pCWF", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0d9898c9e847c9be$export$e1b8a1ae03e64401 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8AYRE",
    name: "ContextualCreateContentPopoverLoader",
    loader: async ()=>(await (parcelRequire("ddMgn"))).ContextualCreateContentPopover
});
module.exports["ContextualCreateContentPopoverLoader"] = $0d9898c9e847c9be$export$e1b8a1ae03e64401;

});

parcelRegister("ddMgn", function(module, exports) {

let $9a01ed5539411b13$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9a01ed5539411b13$var$load("hhu66"),
    $9a01ed5539411b13$var$load("1RnPt"),
    $9a01ed5539411b13$var$load("4fYzp"),
    $9a01ed5539411b13$var$load("llcQo"),
    $9a01ed5539411b13$var$load("jXx9i"),
    $9a01ed5539411b13$var$load("6wr18"),
    $9a01ed5539411b13$var$load("ffEVr"),
    $9a01ed5539411b13$var$load("7EorR"),
    $9a01ed5539411b13$var$load("hhss7"),
    $9a01ed5539411b13$var$load("9F7vX")
]).then(()=>parcelRequire('2to2n'));

});

parcelRegister("6MlZq", function(module, exports) {
const $2b534f0161088f49$export$f5501c77c624c70 = ()=>{
    /**
	 * DO NOT MODIFY THIS METHOD.
	 * This method has been refactored to return true as part of an effort to remove LaunchDarkly feature flags.
	 * Returning true avoids regressions.
	 * This method will be removed when ALL dependent feature flags have been removed.
	 * This work is being tracked in https://hello.jira.atlassian.cloud/browse/CTIA-2808
	 */ return true;
};
module.exports["useIsCreationDropdownEnabled"] = $2b534f0161088f49$export$f5501c77c624c70;

});

parcelRegister("fZkiP", function(module, exports) {

let $ba3c4d3bd3569e1d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ba3c4d3bd3569e1d$var$load("6wr18"),
    $ba3c4d3bd3569e1d$var$load("ffEVr"),
    $ba3c4d3bd3569e1d$var$load("fC3D2")
]).then(()=>parcelRequire('a0Cao'));

});

parcelRegister("fGXGw", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $bl5yp = parcelRequire("bl5yp");

function $3ba3c538e2294e67$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $3ba3c538e2294e67$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $3ba3c538e2294e67$var$start() {
    $3ba3c538e2294e67$var$cleanup();
    $3ba3c538e2294e67$var$unbindEvents = (0, $cbY7C.bindAll)(window, [
        {
            type: 'dragover',
            listener: $3ba3c538e2294e67$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $3ba3c538e2294e67$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $3ba3c538e2294e67$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $3ba3c538e2294e67$var$cleanup
        },
        ...(0, $bl5yp.getBindingsForBrokenDrags)({
            onDragEnd: $3ba3c538e2294e67$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $3ba3c538e2294e67$var$cleanup() {
    $3ba3c538e2294e67$var$unbindEvents?.();
    $3ba3c538e2294e67$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $3ba3c538e2294e67$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $3ba3c538e2294e67$var$cleanup();
}
const $3ba3c538e2294e67$export$453c0582481cc59d = {
    start: $3ba3c538e2294e67$var$start,
    stop: $3ba3c538e2294e67$var$stop
};
module.exports["preventUnhandled"] = $3ba3c538e2294e67$export$453c0582481cc59d;

});

parcelRegister("cIWiw", function(module, exports) {
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $8d2daf016c36a388$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $8d2daf016c36a388$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $8d2daf016c36a388$var$tinyTransparentImage) nativeSetDragImage($8d2daf016c36a388$var$tinyTransparentImage, 0, 0);
}
module.exports["disableNativeDragPreview"] = $8d2daf016c36a388$export$c588cb30ff3b876e;

});

parcelRegister("2aija", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $1tDzb = parcelRequire("1tDzb");


var $gP9iN = parcelRequire("gP9iN");


var $hgbrK = parcelRequire("hgbrK");

const $97165e869498f5e6$var$hideAboveQueries = (0, $gP9iN.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $97165e869498f5e6$var$hideBelowQueries = (0, $hgbrK.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $97165e869498f5e6$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1tDzb.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $lOiVq.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $97165e869498f5e6$var$hideAboveQueries[above],
            below && $97165e869498f5e6$var$hideBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
module.exports["Hide"] = $97165e869498f5e6$export$bed28288a051538;

});

parcelRegister("gP9iN", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $lOiVq = parcelRequire("lOiVq");


var $9vEMa = parcelRequire("9vEMa");


var $gnKXs = parcelRequire("gnKXs");

const $43486d63aa94dbc3$export$918f8818cfbbeb2c = (input)=>{
    return (0, $9vEMa.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $lOiVq.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $gnKXs.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
module.exports["UNSAFE_buildAboveMediaQueryCSS"] = $43486d63aa94dbc3$export$918f8818cfbbeb2c;

});

parcelRegister("9vEMa", function(module, exports) {
const $5e5a55fac3e6fd2a$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
};
const $5e5a55fac3e6fd2a$export$2d293d9871c38e91 = Object.keys($5e5a55fac3e6fd2a$export$e5ee4fe8b989fd09); /**
                                                                                                                                                     * This is our smallest breakpoint with a few nuances to it:
                                                                                                                                                     * 1. It is the default value for shorthands, eg. `<GridItem span={6} />` maps to `{ [SMALLEST_BREAKPOINT]: props.span }`
                                                                                                                                                     * 2. It's omitted in `media.below` as there's nothing below `0px`.
                                                                                                                                                     */ 
const $5e5a55fac3e6fd2a$export$b7ed752a57b4177b = $5e5a55fac3e6fd2a$export$2d293d9871c38e91[0];
module.exports["UNSAFE_BREAKPOINTS_CONFIG"] = $5e5a55fac3e6fd2a$export$e5ee4fe8b989fd09;
module.exports["UNSAFE_BREAKPOINTS_ORDERED_LIST"] = $5e5a55fac3e6fd2a$export$2d293d9871c38e91;

});

parcelRegister("hgbrK", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $lOiVq = parcelRequire("lOiVq");


var $9vEMa = parcelRequire("9vEMa");


var $45mGg = parcelRequire("45mGg");

const $b7e4de65fa0c7921$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $9vEMa.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $lOiVq.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $45mGg.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};
module.exports["UNSAFE_buildBelowMediaQueryCSS"] = $b7e4de65fa0c7921$export$b2a4e2b0c6417297;

});

parcelRegister("kawxu", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $1tDzb = parcelRequire("1tDzb");


var $gP9iN = parcelRequire("gP9iN");


var $hgbrK = parcelRequire("hgbrK");

function $9278a0867c7923b7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9278a0867c7923b7$var$showAboveQueries = (0, $gP9iN.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $9278a0867c7923b7$var$showBelowQueries = (0, $hgbrK.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $9278a0867c7923b7$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $9278a0867c7923b7$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1tDzb.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $lOiVq.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $9278a0867c7923b7$var$defaultHiddenStyles,
            above && $9278a0867c7923b7$var$showAboveQueries[above],
            below && $9278a0867c7923b7$var$showBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
module.exports["Show"] = $9278a0867c7923b7$export$f6a3d19be20f5819;

});

parcelRegister("6cyWf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $350c8455dc4e7cf5$export$d158fa15757a1890 = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $350c8455dc4e7cf5$export$abfcaeeca4ae7a55 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useHasCustomTheme() {
    return (0, $cozmU.useContext)($350c8455dc4e7cf5$export$d158fa15757a1890);
} : function useHasCustomTheme() {
    return (0, $cozmU.useContext)($350c8455dc4e7cf5$export$d158fa15757a1890);
};
module.exports["HasCustomThemeContext"] = $350c8455dc4e7cf5$export$d158fa15757a1890;
module.exports["useHasCustomTheme"] = $350c8455dc4e7cf5$export$abfcaeeca4ae7a55;

});

parcelRegister("aXMFs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");

function $25b427f2364d8f29$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 * This is copied from @atlaskit/button to render IconButtons. Some IconButton's DOM element
 * will be re-created during SSR -> SPA hydration without using this, which delays TTVC. As
 * IconRenderer is already used in @atlaskit/button to mitigate this issue, add it here to
 * mitigate the same issue for IconButtons in navigation-system, especially for ThemedIconButton.
 *
 */ const $25b427f2364d8f29$var$IconRenderer = ({ icon: Icon })=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const isRenderProp = $25b427f2364d8f29$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $iDrrr.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, iconProps));
};
var $25b427f2364d8f29$export$2e2bcd8739ae039 = $25b427f2364d8f29$var$IconRenderer;
module.exports["default"] = $25b427f2364d8f29$export$2e2bcd8739ae039;

});

parcelRegister("5dijw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $iDrrr = parcelRequire("iDrrr");


var $hBYtq = parcelRequire("hBYtq");


var $hVZgb = parcelRequire("hVZgb");

const $33036e997e9cb956$var$styles = {
    root: "_2mHwu8gVvo _2sNsIgmnOE _0bjKvDKTcp _23rrnHoacQ _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _4c065UPgdg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VymQ6 _1mT5xdRAKS _3WzCGi98eZ _32C2rk98eZ _0DCa9D98eZ _0NqVRtYbGa _0i9AWAYbGa _3932vvYbGa _3BKYwu6wH8 _0mm6KQ6wH8 _02cRtH6wH8",
    interactiveMotion: "_23rrnH7alE _3sFUREziSy",
    border: "_2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _0GBAIrogpp _2WYcYGWVPG",
    selected: "_2uo31fhe06 _1UtDYzysOt _0z8nYC0GCl _10n1R5ysOt _2nTuUYysOt _30zrXRUQDy _0clgaMysOt _1gxogc4k8R _0CMRbkysOt",
    disabled: "_2uo31ftHCb _1UtDYzn3Ip _0z8nYCjOvk _10n1R5n3Ip _2nTuUYn3Ip _30zrXRtHCb _0clgaMn3Ip _1gxogctHCb _0CMRbkn3Ip"
};
const $33036e997e9cb956$var$shapeStyles = {
    default: "_2Y7lL48HPE",
    square: "_2Y7lL4Pgdg _39xV02ymQ6 _26BoRwdnbC"
};
const $33036e997e9cb956$var$appearanceStyles = {
    default: "_2uo31fGfro _1UtDYz98eZ _0z8nYCQMmr _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    subtle: "_2uo31fGfro _1UtDYz98eZ _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    primary: "_2uo31fxjIo _1UtDYzwGpT _10n1R5wGpT _2nTuUYwGpT _30zrXR2rJx _0clgaMwGpT _1gxogcHVA2 _0CMRbkwGpT"
}; /**
    * Props shared by `ThemedPressable` and `ThemedAnchor`
    */ 
const $33036e997e9cb956$export$66240319f1f78d74 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(20);
    let T0;
    let appearance;
    let hasBorder;
    let isDisabled;
    let isSelected;
    let shape;
    let t1;
    if ($[0] !== t0) {
        const { appearance: t2, shape: t3, isSelected: t4, isDisabled: t5, ...props } = t0;
        isSelected = t4;
        isDisabled = t5;
        appearance = t2 === undefined ? "default" : t2;
        shape = t3 === undefined ? "default" : t3;
        hasBorder = appearance === "default" || isSelected;
        T0 = (0, $hBYtq.Pressable);
        t1 = (0, $hVZgb.getPrimitiveSpreadProps)(props);
        $[0] = t0;
        $[1] = T0;
        $[2] = appearance;
        $[3] = hasBorder;
        $[4] = isDisabled;
        $[5] = isSelected;
        $[6] = shape;
        $[7] = t1;
    } else {
        T0 = $[1];
        appearance = $[2];
        hasBorder = $[3];
        isDisabled = $[4];
        isSelected = $[5];
        shape = $[6];
        t1 = $[7];
    }
    const t2 = $33036e997e9cb956$var$shapeStyles[shape];
    const t3 = hasBorder && $33036e997e9cb956$var$styles.border;
    const t4 = $33036e997e9cb956$var$appearanceStyles[appearance];
    const t5 = isSelected && $33036e997e9cb956$var$styles.selected;
    const t6 = isDisabled && $33036e997e9cb956$var$styles.disabled;
    let t7;
    if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
        t7 = (0, $k12R1.cx)($33036e997e9cb956$var$styles.root, t2, t3, t4, t5, t6, (0, $iDrrr.fg)("platform-dst-motion-uplift-button") && $33036e997e9cb956$var$styles.interactiveMotion);
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== T0 || $[15] !== isDisabled || $[16] !== ref || $[17] !== t1 || $[18] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            ref: ref,
            type: "button",
            xcss: t7,
            isDisabled: isDisabled
        });
        $[14] = T0;
        $[15] = isDisabled;
        $[16] = ref;
        $[17] = t1;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    return t8;
} : ({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref)=>{
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        ...(0, $hVZgb.getPrimitiveSpreadProps)(props),
        ref: ref,
        type: "button",
        /**
                                                                                * We are using some style values that are outside of the strict
                                                                                * `@atlaskit/css` types.
                                                                                */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $k12R1.cx)($33036e997e9cb956$var$styles.root, $33036e997e9cb956$var$shapeStyles[shape], hasBorder && $33036e997e9cb956$var$styles.border, $33036e997e9cb956$var$appearanceStyles[appearance], isSelected && $33036e997e9cb956$var$styles.selected, isDisabled && $33036e997e9cb956$var$styles.disabled, (0, $iDrrr.fg)('platform-dst-motion-uplift-button') && $33036e997e9cb956$var$styles.interactiveMotion),
        isDisabled: isDisabled
    });
});
module.exports["ThemedPressable"] = $33036e997e9cb956$export$66240319f1f78d74;

});

parcelRegister("hVZgb", function(module, exports) {
/**
 * Props from primitives that we explicitly ignore and remove from spread props,
 * because they apply styles.
 *
 * `css` / `className` are not here because primitives don't support them.
 *
 * See `packages/design-system/primitives/src/components/anchor.tsx` and `packages/design-system/primitives/src/components/pressable.tsx`
 * for where these are defined. These shouldn't change very often as the direction is `xcss` over individual props.
 */ function $c03f86859c8952b6$export$e4c95325a21f9785({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
}
module.exports["getPrimitiveSpreadProps"] = $c03f86859c8952b6$export$e4c95325a21f9785;

});


//# sourceMappingURL=PagesItemActions.8bbf378a.js.map
